var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5604_9417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0082 1.5625L22.4004 13.1547L25.2867 6.31544L38.0082 1.5625Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97656 1.5625L17.4589 13.2645L14.7138 6.31544L1.97656 1.5625Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3932 28.4336L28.2363 34.8022L37.1304 37.2493L39.6873 28.5748L32.3932 28.4336Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.330078 28.5748L2.87125 37.2493L11.7654 34.8022L7.60851 28.4336L0.330078 28.5748Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2636 17.6732L8.78516 21.4223L17.6165 21.8144L17.3028 12.3242L11.2636 17.6732Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.722 17.6717L22.6043 12.2129L22.4004 21.8129L31.2161 21.4207L28.722 17.6717Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 34.8014L17.0676 32.2132L12.4872 28.6367L11.7656 34.8014Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.918 32.2132L28.2356 34.8014L27.4984 28.6367L22.918 32.2132Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2356 34.8011L22.918 32.2129L23.3415 35.6796L23.2944 37.1384L28.2356 34.8011Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 34.8011L16.7068 37.1384L16.6754 35.6796L17.0676 32.2129L11.7656 34.8011Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7849 26.3466L12.3613 25.0446L15.4829 23.6172L16.7849 26.3466Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1992 26.3466L24.5012 23.6172L27.6384 25.0446L23.1992 26.3466Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7643 34.8022L12.5172 28.4336L7.60742 28.5748L11.7643 34.8022Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4824 28.4336L28.2354 34.8022L32.3922 28.5748L27.4824 28.4336Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2161 21.4219L22.4004 21.814L23.2161 26.3474L24.518 23.618L27.6553 25.0454L31.2161 21.4219Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3597 25.0454L15.4969 23.618L16.7832 26.3474L17.6146 21.814L8.7832 21.4219L12.3597 25.0454Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78516 21.4219L12.4871 28.6376L12.3616 25.0454L8.78516 21.4219Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6549 25.0454L27.498 28.6376L31.2157 21.4219L27.6549 25.0454Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6165 21.8145L16.7852 26.3478L17.8204 31.6968L18.0557 24.6537L17.6165 21.8145Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4001 21.8145L21.9766 24.638L22.1648 31.6968L23.2158 26.3478L22.4001 21.8145Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.215 26.3469L22.1641 31.6959L22.917 32.2135L27.4974 28.6371L27.6543 25.0449L23.215 26.3469Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3613 25.0449L12.4868 28.6371L17.0672 32.2135L17.8202 31.6959L16.7849 26.3469L12.3613 25.0449Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.295 37.138L23.3421 35.6792L22.9499 35.3341H17.0362L16.6754 35.6792L16.7068 37.138L11.7656 34.8008L13.4911 36.2125L16.9892 38.6439H22.997L26.5107 36.2125L28.2362 34.8008L23.295 37.138Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.917 32.213L22.164 31.6953H17.8189L17.066 32.213L16.6738 35.6796L17.0346 35.3345H22.9483L23.3405 35.6796L22.917 32.213Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.667 13.9076L40.0003 7.5076L38.0082 1.5625L22.918 12.7625L28.7219 17.6723L36.9258 20.0723L38.7454 17.9547L37.9611 17.39L39.216 16.2449L38.2435 15.4919L39.4984 14.5351L38.667 13.9076Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5076L1.33333 13.9076L0.486275 14.5351L1.74118 15.4919L0.784314 16.2449L2.03922 17.39L1.2549 17.9547L3.05882 20.0723L11.2627 17.6723L17.0667 12.7625L1.97647 1.5625L0 7.5076Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9255 20.0719L28.7216 17.6719L31.2157 21.4209L27.498 28.6366L32.3922 28.5738H39.6863L36.9255 20.0719Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2634 17.6719L3.05949 20.0719L0.330078 28.5738H7.60851L12.4869 28.6366L8.78498 21.4209L11.2634 17.6719Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3992 21.8144L22.9168 12.7635L25.3011 6.31641H14.7129L17.0658 12.7635L17.6149 21.8144L17.8031 24.6693L17.8188 31.6968H22.1639L22.1952 24.6693L22.3992 21.8144Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5604_9417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.53a59ec24b57a5a65e311d23a7c53e24.svg";
export { ForwardRef as ReactComponent };